import React from 'react';
import { ReactComponent as Icon } from '../../../../../assets/icons/monCompte/duplicate.svg';

function Duplicate({ width = '30px', color = 'var(--grey)', className = '', onClick }) {
  return (
    <Icon
      style={{ '--color': color, 'stroke': 'var(--color)', 'cursor': onClick ? 'pointer' : '' }}
      width={width}
      height={width}
      className={className + (onClick ? ' clickable-icon' : '')}
      onClick={onClick}
    />
  );
}

export default Duplicate;
